import { render, staticRenderFns } from "./CopyBuilding.vue?vue&type=template&id=81169b66"
import script from "./CopyBuilding.vue?vue&type=script&lang=js"
export * from "./CopyBuilding.vue?vue&type=script&lang=js"
import style0 from "./CopyBuilding.vue?vue&type=style&index=0&id=81169b66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports